export default __webpack_public_path__ + "static/media/bees-n-flowers.97e53b2a.png";